/**
 * A piece is "past due" when it's still marked `scheduled` but its publish
 * time has already passed — it missed (or is missing) its slot and needs the
 * operator's attention. Auto-publish pieces eventually get swept to `failed`
 * after a grace window, but manual-publish pieces — and anything just dragged
 * onto a time in the past — sit in this state until they're rescheduled.
 *
 * Note: this reads the wall clock at render time, so a piece flips to past-due
 * the moment its slot time passes (no server round-trip needed).
 */
export function isSchedulePastDue(
  publishingStatus: string,
  publishAt: string | null | undefined,
): boolean {
  if (publishingStatus !== "scheduled" || !publishAt) return false
  return new Date(publishAt).getTime() < Date.now()
}
